var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-tracking-no-tracking-pane"},[_c('span',{staticClass:"no-value"},[_vm._v("\n    "+_vm._s(_vm.__('No estimate or time spent'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }